(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cure-main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
  constructor() {
  super();
  }

  hide() {
  super.hide();
  }

  show(opener) {
  super.show(opener);
  this.showActiveMedia();
  }

  showActiveMedia() {
  this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
  element.classList.remove('active');
  }
  )
  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
  const activeMediaTemplate = activeMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
  activeMedia.classList.add('active');
  activeMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

  if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
  activeMedia.loadContent();
  }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  /*recharge subscription labels - separate price from text for alignment purposes*/
  //console.log('is this working');
  //console log all of the the different variant prices

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
      const subLabel = document.querySelectorAll('.rc-radio__subscription');
      //console.log(subLabel[0], "sublabel")
      //replace the two characters before the % sign with 20
      subLabel[0].innerHTML = "Subscribe and Save 20%";
      //get the single, 2pack and 3pack prices from the ProductJSON element
      //create span to wrap the price in and give it the same class as the subscription price
      const rcPriceSpan = document.createElement('span');
      rcPriceSpan.classList.add('rc-radio__price');
      //get the product data
      const productJSONString = document.getElementById('ProductJSON').value;
      const product = JSON.parse(productJSONString);
      const singlePack = product.variants.find(variant => variant.title.includes("1 pack"));
      const twoPack = product.variants.find(variant => variant.title.includes("2 pack"));
      const threePack = product.variants.find(variant => variant.title.includes("3 pack"));

      //grab the first radio element as it's the only one we need to change
      const rcNoSubscriptionLabel = document.querySelectorAll('.rc-radio')[0];
      //grab the label element
      const rcNoSubscriptionLabelText = document.querySelectorAll('.rc-radio__label')[0];

      //split label inner text on the dollar sign - ps: this removes the dollar sign
      let rcNoSubscriptionLabelTextItems = rcNoSubscriptionLabelText.innerText.split('$');

      //append price span to label
      rcNoSubscriptionLabel.append(rcPriceSpan);

      //set label inner text with the first bit
      rcNoSubscriptionLabelText.innerText = rcNoSubscriptionLabelTextItems[0];

      //set price span inner text with the a dollar sign + the price text
      rcPriceSpan.innerHTML = `&dollar;`+`${rcNoSubscriptionLabelTextItems[1]}`;
      //get the product data from the page
      //assign the product object to a variable
      
      //get all radio buttons
      const rcRadioButtons = document.querySelectorAll('label');
      //console.log(rcRadioButtons)
      rcRadioButtons.forEach((radio, i) => {
        radio.addEventListener('click', (e) => {
          subLabel[0].innerHTML = "Subscribe and Save 20%";
          if(i === 1) {
            //rcPriceSpan.innerHTML = `&dollar;`+ the price of a single pack. get the price from the product object
            rcPriceSpan.innerHTML = `&dollar;`+`${singlePack.price/100}`;
            //after one second, change the subscription label to 201%
            setTimeout(() => {
              subLabel[0].innerHTML = "Subscribe & Save 20%";
            }, 10);
            //subLabel[0].innerHTML = "Subscribe & Save 20%";
          } else if(i === 2) {
            rcPriceSpan.innerHTML = `&dollar;`+`${twoPack.price/100}`;
            setTimeout(() => {
              subLabel[0].innerHTML = "Subscribe & Save 20%";
            }, 10);
          } else if(i === 3) {
            rcPriceSpan.innerHTML = `&dollar;`+`${threePack.price/100}`;
            setTimeout(() => {
              subLabel[0].innerHTML = "Subscribe & Save 20%";
            }, 10);
          }
        });
      });
      
    }, 900);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-set-experience"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const fullSetSection = document.querySelector('.full-set-experience');

    const fullSetTitle = document.querySelector('.full-set-section-row1 .new-homepage-title-small');

    const fullSetButton = document.querySelector('.full-set-section-row1 .new-homepage-button');

    let FsSectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (window.innerWidth < 768 && entry.isIntersecting && entry.intersectionRatio >= 0.15) {
          fullSetTitle.classList.add('section-title-animation');
          fullSetButton.classList.add('section-title-animation');
          FsSectionObserver.unobserve(fullSetSection);
        }
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          fullSetTitle.classList.add('section-title-animation');
          fullSetButton.classList.add('section-title-animation');
          FsSectionObserver.unobserve(fullSetSection);
        };
      });
    }, {
      threshold: [0.15, 0.2]
    });

    FsSectionObserver.observe(fullSetSection);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-cyber"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-brand-icons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const brandIconSection = document.querySelector('.brand-icons-section');

    const brandIcons = document.querySelectorAll('.brand-icons-grid img');

    let brandIconsSectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          brandIcons.forEach(icon => {
            icon.classList.add('section-text-fade-in');
          })
        }
      });
    }, {threshold: 0.1});

    brandIconsSectionObserver.observe(brandIconSection);
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
  constructor() {
  super();
  }

  hide() {
  super.hide();
  }

  show(opener) {
  super.show(opener);
  this.showActiveMedia();
  }

  showActiveMedia() {
  this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
  element.classList.remove('active');
  }
  )
  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
  const activeMediaTemplate = activeMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
  activeMedia.classList.add('active');
  activeMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

  if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
  activeMedia.loadContent();
  }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mains-cart-footer-bb-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbg"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mbgSection = document.querySelector('.mgb-section');
    const mbgContent = document.querySelector('.mbg-content');

    let mbgSectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (window.innerWidth < 768 && entry.isIntersecting && entry.intersectionRatio >= 0) {
          mbgContent.classList.add('animated-column');
          mbgSectionObserver.unobserve(mbgSection);
        } else if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          mbgContent.classList.add('animated-column');
          mbgSectionObserver.unobserve(mbgSection);
        };
      });
    }, {
      threshold: [0, 0.2]
    });

    mbgSectionObserver.observe(mbgSection);

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-your-mushrooms-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const meetYourMushrooms = document.querySelector('.meet-your-mushrooms-section');

    const meetYourMushroomsTitle = document.querySelector('.meet-your-mushrooms-homepage-wrapper .new-homepage-title-small');

    const meetYourMushroomsCards = Array.from(document.getElementsByClassName('meet-your-mushrooms-homepage-card'));

    let MymSectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (window.innerWidth < 768 && entry.isIntersecting && entry.intersectionRatio >= 0) {
          meetYourMushroomsTitle.classList.add('section-text-fade-in');
          meetYourMushroomsCards.forEach(card => {
            card.classList.add('animated-card');
            MymSectionObserver.unobserve(meetYourMushrooms);
          });
        } else if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          meetYourMushroomsTitle.classList.add('section-text-fade-in');
          meetYourMushroomsCards.forEach(card => {
            card.classList.add('animated-card');
            MymSectionObserver.unobserve(meetYourMushrooms);
          });
        }
      });
    }, {
      threshold: [0, 0.2]
    });

    MymSectionObserver.observe(meetYourMushrooms);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["power-of-mushrooms-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const powerOfMushroomsSection = document.querySelector('.power-of-mushrooms-section');

    const powerOfMushroomsTitle = document.querySelector('.power-of-mushrooms-title');

    const powerOfMushroomsCards = Array.from(document.getElementsByClassName('power-of-mushroom-card'));

    let PomSectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (window.innerWidth < 768 && entry.isIntersecting && entry.intersectionRatio >= 0) {
          powerOfMushroomsTitle.classList.add('section-text-fade-in');
          powerOfMushroomsCards.forEach(card => {
            card.classList.add('animated-card');
            PomSectionObserver.unobserve(powerOfMushroomsSection);
          });
        } else if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          powerOfMushroomsTitle.classList.add('section-text-fade-in');
          powerOfMushroomsCards.forEach(card => {
            card.classList.add('animated-card');
            PomSectionObserver.unobserve(powerOfMushroomsSection);
          });
        }
      });
    }, {
      threshold: [0, 0.5]
    });

    PomSectionObserver.observe(powerOfMushroomsSection);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quizify-js"] && !Shopify.designMode) return;
  try {
     
//const timeout = (ms) => {
//	return new Promise(resolve => setTimeout(resolve, ms));
//}
//const foo = asyn c function() {
//	let iframe = null;
//	while (iframe === null) {
//		await timeout(1000);
//		iframe = document.querySelector('#iframeid');
//	}
//	iframe.addEventListener('load', async () => {
//		let powered = null;
//   	while (powered === null) {
//        	await timeout(1000);
//            powered = iframe.contentWindow.document.querySelector('.quiz_frame_form.user-form + div');
//            console.log('aqui', powered)
//      	}
//	})
//}
//window.addEventListener('load', foo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tincture-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tinctureSection = document.querySelector('.tincture-banner-section');

    const tinctureSectionTitle = document.querySelector('.tincture-banner-section .new-homepage-title-smaller');

    const tinctureSectionText = document.querySelector('.tincture-banner-section .homepage-tincture-banner-text');

    const tinctureSectionButton = document.querySelector('.tincture-banner-section .new-homepage-button');

    const tinctureSectionImgMobile = document.querySelector('.homepage-tincture-banner-product-img.mobile');

    let tinctureSectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          tinctureSectionTitle.classList.add('section-title-animation');
          tinctureSectionText.classList.add('section-title-animation');
          tinctureSectionButton.classList.add('section-title-animation');
          tinctureSectionImgMobile.classList.add('animated-img');
        }
      });
    }, {threshold: 0.2});

    tinctureSectionObserver.observe(tinctureSection);
  })


  } catch(e) { console.error(e); }
})();
})();
